import { Link } from "@tanstack/react-router";
import { getCurrentChapter } from "@/config/chapters";

type FooterLink = { label: string; to?: string; hash?: string };

const columns: { title: string; links: FooterLink[] }[] = [
  {
    title: "Shop",
    links: [
      { label: "The Current Chapter", to: "/products" },
      // Chapter Vials are only linked while a chapter offers them.
      ...(getCurrentChapter().vialsAvailable
        ? [{ label: "Chapter Vials", to: "/products/chapter-vials" }]
        : []),
      { label: "How It Works", to: "/how-it-works" },
      { label: "Release List", to: "/", hash: "release-access" },
      { label: "Field Notes", to: "/field-notes" },
    ],
  },

  {
    title: "House",
    links: [
      { label: "Our Story", to: "/about" },
      { label: "The Method", to: "/about", hash: "method" },
      { label: "Contact", to: "/about", hash: "contact" },
    ],
  },
  {
    title: "Care",
    links: [
      { label: "Shipping & Returns", to: "/faq" },
      { label: "The Vial Promise", to: "/how-it-works" },
      { label: "FAQ", to: "/faq" },
    ],
  },
];

export function SiteFooter() {
  return (
    <footer className="border-t border-border bg-card/30">
      <div className="mx-auto max-w-7xl px-6 py-16">
        <div className="grid gap-12 md:grid-cols-[1.4fr_repeat(3,1fr)]">
          <div>
            <div className="leading-none">
              <span className="block font-display text-[0.6rem] tracking-[0.4em] text-gold/80">
                HOUSE OF
              </span>
              <span className="font-display text-2xl tracking-[0.18em] text-gradient-gold">
                APOCRYPHA
              </span>
            </div>
            <p className="mt-5 max-w-xs text-lg leading-relaxed text-muted-foreground">
              Natural perfumes, released in seasonal chapters.
            </p>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h4 className="font-display text-xs uppercase tracking-[0.24em] text-gold">
                {col.title}
              </h4>
              <ul className="mt-5 space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    {l.to ? (
                      <Link
                        to={l.to}
                        hash={l.hash}
                        className="text-base text-muted-foreground transition-colors hover:text-parchment"
                      >
                        {l.label}
                      </Link>
                    ) : (
                      <span className="text-base text-muted-foreground/70">{l.label}</span>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="ornament mt-14">
          <span>✶</span>
        </div>

        <p className="mt-8 text-center text-sm uppercase tracking-[0.2em] text-muted-foreground/70">
          © {new Date().getFullYear()} House of Apocrypha
        </p>
      </div>
    </footer>
  );
}
